import { Component, ViewEncapsulation } from '@angular/core';
import { NutritionFacadeService } from '@emm/management/services/nutrition-facade.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-nutrition-assignments-right-header',
    styleUrls: ['./nutrition-assignments-right-header.component.scss'],
    templateUrl: './nutrition-assignments-right-header.component.html',
    standalone: false
})
export class NutritionAssignmentsRightHeaderComponent {

    location$ = this.nutritionFacade.location$;

    constructor(private nutritionFacade: NutritionFacadeService) {}

}
